module.exports = {
      id: "author-avator-usage",
      viewBox: "0 0 102 102",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#author-avator",
      toString: function () {
        return this.url;
      }
    }